import NoData from "@/components/NoData";
import LtdLoading from "@/components/LichThiDauFull/LtdLoading";
import useLichThiDauByLeague from "@/components/LichThiDauByLeague/useLichThiDauByLeague";
import LeagueSelect from "./LeagueSelect";
import MatchList from "./MatchList";
import "@/components/LichThiDauFull/index.css";
import "./index.css";

/**
 * @param {object} props
 * @param {string} props.league
 */
export default function LichThiDauByLeagueSidebar({ league: leagueSlug }) {
  const {
    themeStyle,
    activeSlug,
    setActiveSlug,
    league,
    initialMatchesEntries,
    waiting,
    failed,
  } = useLichThiDauByLeague(leagueSlug);

  return (
    <div className="kbv-ltd-full kbv-ltd-sb" style={themeStyle}>
      <div className="kbv-ltd-sb-filters">
        <LeagueSelect
          selectedSlug={activeSlug}
          currentLeague={league}
          onSelect={setActiveSlug}
          themeStyle={themeStyle}
        />
      </div>
      {failed ? (
        <NoData message="Không có trận đấu" />
      ) : !activeSlug || waiting ? (
        <LtdLoading compact />
      ) : (
        <MatchList
          key={league.id}
          league={league}
          initialMatchesEntries={initialMatchesEntries}
          themeStyle={themeStyle}
        />
      )}
    </div>
  );
}
